
    import { Component, Vue, Prop } from 'vue-property-decorator';
    
    import { stepInfoType } from "@/types/Application";
    import StepBase from "../StepBase.vue";
    import NextSteps from "./NextSteps.vue";
    import FilingOptions from "./FilingOptions.vue"
    import ReviewAndPrint from "./ReviewAndPrint.vue"
    import ReviewAndSave from "./ReviewAndSave.vue"
    import ReviewAndSubmit from "./ReviewAndSubmit.vue"


    @Component({
        components:{
            StepBase,
            FilingOptions,
            ReviewAndPrint,
            ReviewAndSave,
            ReviewAndSubmit,
            NextSteps
        }
    })

    export default class submit extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;
        
    }
